import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Observable } from 'rxjs';

import { IPhase } from 'phase/phase';

import { CoachingPlanController } from './coaching-plan.controller';
import { CoachingPlanStore } from './coaching-plan.store';

@Component({
	selector: 'spr-coaching-plan',
	templateUrl: './coaching-plan.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [CoachingPlanStore, CoachingPlanController],
	host: {
		class: 'flex relative items-stretch flex-col',
	},
})
export class CoachingPlanComponent {
	constructor(public controller: CoachingPlanController) {}

	public trackByPhase(index: number, phase: IPhase): string {
		return phase.id;
	}

	public onTabClick(index: number) {
		this.controller.switchTab(index);
	}
}
